export default "__VITE_ASSET__CQQ1tU2V__"